import { Component, Input, OnInit, SimpleChanges } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../../shared/components/table-list/table-list.component'
import { OperationStatusService } from '../../../../core/services/operation/operation-status/operation-status.service'
import { AuthService } from '../../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import { PagedContactTypeResponse } from '../../../../core/models/contact-type.model'
import { IndividualClientService } from '../../../../core/services/customer/individual-client/individual-client.service'
import { SubClientService } from '../../../../core/services/customer/sub-client/sub-client.service'
import { FormClientSearchComponent } from '../../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../../shared/utils/utils'
import { SubClientEditComponent } from '../../../../features/customer/sub-client/sub-client-edit/sub-client-edit.component'
import { VehicleService } from '../../../../core/services/vehicle/vehicle/vehicle.service'
import { VehicleEditComponent } from '../../../../features/vehicle/vehicle-register/vehicle-edit/vehicle-edit.component'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'

@Component({
  selector: 'vehicle-supplier',
  imports: [
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    FormClientSearchComponent,
  ],
  templateUrl: './vehicle-supplier.component.html',
  styleUrl: './vehicle-supplier.component.scss',
  standalone: true,
  providers: [OperationStatusService, IndividualClientService, AuthService],
})
export class VehicleSupplierComponent implements OnInit {
  constructor(
    private subClientService: SubClientService,
    private authService: AuthService,
    private dialog: MatDialog,
    private vehicleService: VehicleService,
    private snackbar: SnackbarCustomService
  ) { }


  @Input() listRefresh: any

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'supplier',
      key: 'razaoSocial',
      description: 'Fornecedor',
    },
    {
      keyColumn: 'typeVehicle',
      key: 'descricaoTipoVeiculo',
      description: 'Tipo Veiculo',
    },
    {
      keyColumn: 'model',
      key: 'modelo',
      description: 'Modelo',
    },
    {
      keyColumn: 'fleet',
      key: 'placa',
      description: 'Placa',
    },
    {
      keyColumn: 'cnpj',
      key: 'cnpj',
      description: 'Cnpj',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false },
      description: 'Ações',
    },
  ]

  listSearch: any = [
    { id: 'nome', description: 'Nome', type: 'string', visible: true },
    // { id: 'cpf', description: 'CPF', type: 'string', visible: true },
    {
      id: 'razaoSocial',
      description: 'Razão Social',
      type: 'string',
      visible: true,
    },
    { id: 'cnpj', description: 'Cnpj', type: 'string', visible: true },
    {
      id: 'inscMunicipal',
      description: 'Inscrição Municipal',
      type: 'string',
      visible: false,
    },
    {
      id: 'inscEstadual',
      description: 'Inscrição Estadual',
      type: 'string',
      visible: false,
    },
  ]

  inputSearch: any = { type: '', search: '' }
  searchForm: any = { search: false, model: {} }

  screen: string = 'status operação'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['listRefresh'] && changes['listRefresh'].currentValue) {
      this.getListItems();
    }
  }


  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: true,
        // delete: this.checkPermission('deletar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  // search(event: any) {
  //   let search = event
  //   this.page = 1
  //   if (search) {
  //     this.searchForm.descricao = search
  //     this.searchListItems()
  //   } else {
  //     this.getListItems()
  //   }
  // }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  createModel(element: any) {
    let model: any = {}
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }

    this.getListItems()

  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.vehicleService.searchPagedVehicleFrotSupplier(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => { },
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    this.subClientService
      .searchPagedSubClient(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(VehicleEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item, frota: false },
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.getListItems()
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
    this.vehicleService.deleteVehicle(item.id).subscribe({
      next: (response: any) => {
        this.snackbar.success('Deletado com Sucesso')
        this.uploadList()
        this.getListItems()
      },
      error: (err: PagedContactTypeResponse) => { },
      complete: () => { },

    })
  }
}
